import * as z from "zod";
import { mutator } from "./mutator";

/**
 * Telemetry mutator that fires during normal navigation. Uses
 * `swallowError: true` so a benign race (e.g. user viewing a workflow
 * when it's deleted, or hydrated from stale Zero state) resolves to
 * `null` and the mutation no-ops instead of throwing — which would
 * otherwise show up as an OTel-recorded exception on every navigation
 * race and trigger Zero's optimistic-mutation rollback.
 */
export const markWorkflowViewed = mutator({
  schema: z.object({ workflowId: z.string() }),
  resolve: {
    workflow: {
      kind: "workflow",
      from: "workflowId",
      swallowError: true,
    },
  },
  // Viewing a workflow presupposes reading it, so a view row for an
  // unreadable workflow is never legitimate. Skipped when the workflow
  // resolved to null (deletion race); the fn then no-ops.
  permissions: [
    {
      permission: "space:read",
      scopeId: ({ args }) => args.workflow?.spaceId ?? null,
    },
  ],
  fn: async ({ tx, ctx, args: { workflow } }) => {
    if (!workflow) return;
    const { userId } = ctx;
    await tx.mutate.workflowViews.upsert({
      workflowId: workflow.id,
      userId,
      lastSeenAt: Date.now(),
      tenantId: ctx.tenantId,
    });
  },
});
